import { Sidebar } from 'rsuite';
import styled from 'styled-components';

export const SidebarStyled = styled(Sidebar)`
  max-width: 425px;
  min-width: 340px;
  flex: 0 0 33.3333% !important;
  border-right: 1px solid #DBDBDB;
`;
